import React from 'react';
import { useStopwatch } from 'react-timer-hook';
import styled from 'styled-components';
import { when } from 'utils';

const Container = styled.h3<{ red: boolean }>`
  color: white;
  width: 5.5rem;
  margin: 0;

  ${when('red')`
    color: red;
  `}

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const Timer = ({
  maxLengthInSeconds,
  startEpochMs,
}: {
  maxLengthInSeconds: string;
  startEpochMs?: number;
}) => {
  // When a start timestamp is provided (e.g. the guest reading the host's
  // recording start), seed the stopwatch with the already-elapsed time so the
  // displayed value matches the host instead of restarting from 00:00.
  // Memoized so the Date instance stays stable across the per-second re-renders
  // useStopwatch triggers — a fresh offset each render can make it re-seed/drift.
  const offsetTimestamp = React.useMemo(() => {
    const date = new Date();
    if (startEpochMs && Number.isFinite(startEpochMs)) {
      const elapsedSeconds = Math.max(0, Math.floor((Date.now() - startEpochMs) / 1000));
      date.setSeconds(date.getSeconds() + elapsedSeconds);
    }
    return date;
  }, [startEpochMs]);

  const { seconds, minutes, hours } = useStopwatch({ autoStart: true, offsetTimestamp });
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  return (
    <div>
      <Container red={totalSeconds > parseInt(maxLengthInSeconds)}>
        {(minutes.toString().length === 1 ? '0' + minutes : minutes) +
          ':' +
          (seconds.toString().length === 1 ? '0' + seconds : seconds)}
      </Container>
    </div>
  );
};

export default Timer;
